import { z } from 'zod';

export const CATEGORIAS_DESPESA = [
  'Mercadoria e Estoque',
  'Embalagem e Entrega',
  'Contas Fixas e Aluguel',
  'Ferramentas e Assinaturas',
  'Marketing e Divulgação',
  'Impostos e Taxas',
  'Meu Salário (Pró-labore)',
  'Outros Gastos'
] as const;

export const despesaSchema = z.object({
  descricao: z.string().min(2, 'A descrição deve ter pelo menos 2 caracteres'),
  valor: z.number().positive('O valor deve ser maior que zero'),
  data: z.string().datetime({ message: 'Data inválida (formato ISO requerido)' }),
  categoria: z.enum(CATEGORIAS_DESPESA, { errorMap: () => ({ message: 'Categoria inválida' }) }).optional(),
  status: z.enum(['pendente', 'paga']),
  recorrente: z.boolean().default(false),
  id: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

export type Despesa = z.infer<typeof despesaSchema>;
